import type { Language } from "@app/constants";

interface Messages {
	accountSelectionHeader: string;
	accountsHeader: string;
	spousesAccountsHeader: string;
	bankNameText: string;
	bankName: string;
	accountNumberText: string;
	accountNumber: string;
	addNewBankAccountButton: string;
	withdrawAllDropdownItems: {
		yes: string;
		no: string;
	};
	noResults: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		accountSelectionHeader: "Select an account",
		accountsHeader: "Your accounts",
		spousesAccountsHeader: "Spouse's accounts",
		bankNameText: "Bank Name",
		bankName: "",
		accountNumberText: "Account Number",
		accountNumber: "",
		addNewBankAccountButton: "ADD BANK ACCOUNT",
		withdrawAllDropdownItems: {
			yes: "Yes",
			no: "No",
		},
		noResults: "No Accounts to display",
	},
};

export default messages;
